import 'primeflex/primeflex.css';
import 'vue-advanced-cropper/dist/style.css';
import '@cyhnkckali/vue3-color-picker/dist/style.css';
import './assets/styles/variables.css';
import '@/sass/main.scss';

import { createApp } from 'vue';

import { createPinia } from 'pinia';
import { Userpilot } from 'userpilot';
import PrimeVue from 'primevue/config';
import Vue3Lottie from 'vue3-lottie';
import { plugin, defaultConfig } from '@formkit/vue';
import { vuePlugin as launchDarklyPlugin } from '@tagboard/launchdarkly';

import Tooltip from 'primevue/tooltip';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';

// Import core library and component
// not really extraneous but the linter thinks so - TODO: look into it more later
// eslint-disable-next-line import/no-extraneous-dependencies
import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faFacebook,
  faGoogle,
  faInstagram,
  faXTwitter,
  faAmazon,
  faCcStripe,
} from '@awesome.me/kit-a54fb3a664/icons/classic/brands';

// eslint-disable-next-line import/no-extraneous-dependencies
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import icons from '@awesome.me/kit-a54fb3a664' - both solid and regular
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  faArrowRight as fasArrowRight,
  faBlockQuestion as fasBlockQuestion,
  faBold as fasBold,
  faBoltLightning as fasBoltLightning,
  faBookmark as fasBookmark,
  faCheck as fasCheck,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faCirclePlus as fasCirclePlus,
  faCopy as fasCopy,
  faDesktop as fasDesktop,
  faDownload as fasDownload,
  faEllipsis as fasEllipsis,
  faEllipsisVertical as fasEllipsisVertical,
  faFileCsv as fasFileCsv,
  faFlaskVial as fasFlaskVial,
  faFolder as fasFolder,
  faFolderPlus as fasFolderPlus,
  faFontCase as fasFontCase,
  faGrid2 as fasGrid2,
  faGripVertical as fasGripVertical,
  faHashtag as fasHashtag,
  faImage as fasImage,
  faItalic as fasItalic,
  faList as fasList,
  faListOl as fasListOl,
  faMapLocationDot as fasMapLocationDot,
  faMoon as fasMoon,
  faPercent as fasPercent,
  faPersonWalkingArrowRight as fasPersonWalkingArrowRight,
  faQrcode as fasQrcode,
  faRotateReverse as fasRotateReverse,
  faShoppingBasket as fasShoppingBasket,
  faStar as fasStar,
  faStrikethrough as fasStrikethrough,
  faTable as fasTable,
  faText as fasText,
  faUnderline as fasUnderline,
  faUpload as fasUpload,
  faUserXmark as fasUserXmark,
  faVideo as fasVideo,
  faX as fasX,
} from '@awesome.me/kit-a54fb3a664/icons/classic/solid';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  faAlignCenter as farAlignCenter,
  faAlignLeft as farAlignLeft,
  faAlignRight as farAlignRight,
  faArrowDown as farArrowDown,
  faArrowDownFromLine as farArrowDownFromLine,
  faArrowDownZA as farArrowDownZA,
  faArrowLeft as farArrowLeft,
  faArrowLeftFromLine as farArrowLeftFromLine,
  faArrowLeftToLine as farArrowLeftToLine,
  faArrowRight as farArrowRight,
  faArrowRightFromBracket as farArrowRightFromBracket,
  faArrowRightFromLine as farArrowRightFromLine,
  faArrowUp as farArrowUp,
  faArrowUpAZ as farArrowUpAZ,
  faArrowUpFromLine as farArrowUpFromLine,
  faArrowUpRightFromSquare as farArrowUpRightFromSquare,
  faArrowsRotate as farArrowsRotate,
  faBarsFilter as farBarsFilter,
  faBell as farBell,
  faBookmark as farBookmark,
  faBorderBottomRight as farBorderBottomRight,
  faBorderTopLeft as farBorderTopLeft,
  faCalendar as farCalendar,
  faCartPlus as farCartPlus,
  faChartColumn as farChartColumn,
  faChartLine as farChartLine,
  faChartMixed as farChartMixed,
  faChartPie as farChartPie,
  faCheck as farCheck,
  faCircleExclamation as farCircleExclamation,
  faCircleHalfStroke as farCircleHalfStroke,
  faCircleInfo as farCircleInfo,
  faCirclePlus as farCirclePlus,
  faCircleQuestion as farCircleQuestion,
  faClipboard as farClipboard,
  faClone as farClone,
  faCloudXmark as farCloudXmark,
  faCode as farCode,
  faCog as farCog,
  faCopy as farCopy,
  faDisplayCode as farDisplayCode,
  faDownLeftAndUpRightToCenter as farDownLeftAndUpRightToCenter,
  faExchangeAlt as farExchangeAlt,
  faEye as farEye,
  faEyeSlash as farEyeSlash,
  faFileExport as farFileExport,
  faFileImport as farFileImport,
  faFileLines as farFileLines,
  faFilePen as farFilePen,
  faFolder as farFolder,
  faFolderOpen as farFolderOpen,
  faFolderPlus as farFolderPlus,
  faGear as farGear,
  faGripDotsVertical as farGripDotsVertical,
  faInputText as farInputText,
  faLandMineOn as farLandMineOn,
  faLaptop as farLaptop,
  faLaptopCode as farLaptopCode,
  faLink as farLink,
  faListTree as farListTree,
  faLock as farLock,
  faLockOpen as farLockOpen,
  faMagnifyingGlass as farMagnifyingGlass,
  faMessageQuote as farMessageQuote,
  faMinus as farMinus,
  faMobile as farMobile,
  faPalette as farPalette,
  faPaperPlane as farPaperPlane,
  faPaste as farPaste,
  faPen as farPen,
  faPenPaintbrush as farPenPaintbrush,
  faPencil as farPencil,
  faPhotoFilm as farPhotoFilm,
  faPlus as farPlus,
  faPollPeople as farPollPeople,
  faRectangleHistoryCirclePlus as farRectangleHistoryCirclePlus,
  faRectangleVerticalHistory as farRectangleVerticalHistory,
  faRocket as farRocket,
  faScreenUsers as farScreenUsers,
  faScrewdriverWrench as farScrewdriverWrench,
  faShareNodes as farShareNodes,
  faSortNumericDown as farSortNumericDown,
  faSortNumericUp as farSortNumericUp,
  faSpinnerThird as farSpinnerThird,
  faSquarePollVertical as farSquarePollVertical,
  faStar as farStar,
  faStars as farStars,
  faSun as farSun,
  faSunBright as farSunBright,
  faTableLayout as farTableLayout,
  faThumbsDown as farThumbsDown,
  faThumbsUp as farThumbsUp,
  faTrashCan as farTrashCan,
  faTriangleExclamation as farTriangleExclamation,
  faTvRetro as farTvRetro,
  faUpRightAndDownLeftFromCenter as farUpRightAndDownLeftFromCenter,
  faUser as farUser,
  faUserPlus as farUserPlus,
  faUsersMedical as farUsersMedical,
  faWindow as farWindow,
  faWindowRestore as farWindowRestore,
  faXmark as farXmark,
} from '@awesome.me/kit-a54fb3a664/icons/classic/regular';

import {
  faSparkles as fadSparkles,
  faPollPeople as fadPollPeople,
} from '@awesome.me/kit-a54fb3a664/icons/duotone/solid';

import {
  faBookmark as falBookmark,
  faMessageQuote as falMessageQuote,
  faCopy as falCopy,
  faPlus as falPlus,
  faRectangleHistory as falRectangleHistory,
  faRotateReverse as falRotateReverse,
} from '@awesome.me/kit-a54fb3a664/icons/classic/light';

import {
  faTagHome as fakTagHome,
  faTagInteractive as fakTagInteractive,
  faTagGraphics as fakTagGraphics,
  faSocialIsolated as fakSocialIsolated,
  faSocialLowerthird as fakSocialLowerthird,
  faSocialLowerthirdscroll as fakSocialLowerthirdscroll,
  faSocialCinematic as fakSocialCinematic,
  faSocialStories as fakSocialStories,
  faSocialTicker as fakSocialTicker,
  faSocialGrid as fakSocialGrid,
  faSocialWaterfall as fakSocialWaterfall,
  faSocialMural as fakSocialMural,
  faSocialCarousel as fakSocialCarousel,
  faInteractivePoll as fakInteractivePoll,
  faInteractivePollResults as fakInteractivePollResults,
  faInteractiveHeatmap as fakInteractiveHeatmap,
  faInteractiveHashtagMeter as fakInteractiveHashtagMeter,
  faInteractiveHashtagPoll as fakInteractiveHashtagPoll,
  faInteractiveLeaderboard as fakInteractiveLeaderboard,
  faInteractiveCta as fakInteractiveCta,
  faInteractiveCountdown as fakInteractiveCountdown,
  faInteractiveGraphic as fakInteractiveGraphic,
  faInteractiveRedditPoll as fakInteractiveRedditPoll,
  faInteractiveTwitterPoll as fakInteractiveTwitterPoll,
  faInteractiveVimeo as fakInteractiveVimeo,
  faInteractiveYoutube as fakInteractiveYoutube,
  faRegularUsersRotateRight as fakRegularUsersRotateRight,
  faRegularScrewdriverWrenchUser as fakRegularScrewdriverWrenchUser,
  faRegularCodeUser as fakRegularCodeUser,
  faRegularLockKeyholeRotateRight as fakRegularLockKeyholeRotateRight,
  faSportradar as fakSportradar,
  faPhotoshop as fakPhotoshop,
  faTagAnalytics2 as fakTagAnalytics2,
  faTagSocial as fakTagSocial,
  faTagProducer as fakTagProducer,
  faRegularFolderCirclePlus as fakRegularFolderCirclePlus,
  faLightFolderCirclePlus as fakLightFolderCirclePlus,
  faRegularArrowUpShortWideClock as fakRegularArrowUpShortWideClock,
  faRegularArrowDownShortWideClock as fakRegularArrowDownShortWideClock,
  faTagShareit as fakTagShareit,
  faTgbPages as fakTgbPages,
  faFanatics as fakFanatics,
  faSolidTextPen as fakSolidTextPen,
  faHandPointClick as fakHandPointClick,
  faThreads as fakThreads,
  faArrowUTurnUpLeft as fakArrowUTurnUpLeft,
  faArrowUTurnUpRight as fakArrowUTurnUpRight,
} from '@awesome.me/kit-a54fb3a664/icons/kit/custom';

import useThemeSwitcher from '@/composables/useThemeSwitcher';
import instrument from './instrument';
import App from './App.vue';
import router, { setAppInstance } from './router';

import { USERPILOT_TOKEN, USER_API, LAUNCH_DARKLY_CLIENT_ID } from './config/appConfig';

const { themePreference, applyTheme } = useThemeSwitcher();
applyTheme(themePreference.value);

window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', ({ matches }) => {
    if (matches) {
      themePreference.value = 'dark';
    } else {
      themePreference.value = 'light';
    }
  });

library.add(
  // Solid icons
  fasArrowRight,
  fasBlockQuestion,
  fasBold,
  fasBoltLightning,
  fasBookmark,
  fasCheck,
  fasChevronDown,
  fasChevronLeft,
  fasChevronRight,
  fasCirclePlus,
  fasCopy,
  fasDesktop,
  fasDownload,
  fasEllipsis,
  fasEllipsisVertical,
  fasFileCsv,
  fasFlaskVial,
  fasFolder,
  fasFolderPlus,
  fasFontCase,
  fasGrid2,
  fasGripVertical,
  fasHashtag,
  fasImage,
  fasItalic,
  fasList,
  fasListOl,
  fasMapLocationDot,
  fasMoon,
  fasPercent,
  fasPersonWalkingArrowRight,
  fasQrcode,
  fasRotateReverse,
  fasShoppingBasket,
  fasStar,
  fasStrikethrough,
  fasTable,
  fasText,
  fasUpload,
  fasUserXmark,
  fasVideo,
  fasX,
  fasUnderline,

  // Regular icons
  farAlignCenter,
  farAlignLeft,
  farAlignRight,
  farArrowDown,
  farArrowDownFromLine,
  farArrowDownZA,
  farArrowLeft,
  farArrowLeftFromLine,
  farArrowRight,
  farArrowRightFromBracket,
  farArrowRightFromLine,
  farArrowUp,
  farArrowUpAZ,
  farArrowUpFromLine,
  farArrowUpRightFromSquare,
  farArrowsRotate,
  farBarsFilter,
  farBell,
  farBookmark,
  farBorderBottomRight,
  farBorderTopLeft,
  farCalendar,
  farCartPlus,
  farChartColumn,
  farChartLine,
  farChartMixed,
  farChartPie,
  farCheck,
  farCircleExclamation,
  farCircleHalfStroke,
  farCircleInfo,
  farCirclePlus,
  farCircleQuestion,
  farClipboard,
  farClone,
  farCloudXmark,
  farCode,
  farCog,
  farCopy,
  farDisplayCode,
  farDownLeftAndUpRightToCenter,
  farExchangeAlt,
  farEye,
  farEyeSlash,
  farFileExport,
  farFileImport,
  farFileLines,
  farFilePen,
  farFolder,
  farFolderOpen,
  farFolderPlus,
  farGear,
  farGripDotsVertical,
  farGripDotsVertical,
  farInputText,
  farLandMineOn,
  farLaptop,
  farLaptopCode,
  farLink,
  farListTree,
  farLock,
  farLockOpen,
  farMagnifyingGlass,
  farMessageQuote,
  farMinus,
  farMobile,
  farPalette,
  farPaperPlane,
  farPaste,
  farPen,
  farPenPaintbrush,
  farPencil,
  farPhotoFilm,
  farPlus,
  farPollPeople,
  farRectangleHistoryCirclePlus,
  farRectangleVerticalHistory,
  farRocket,
  farScreenUsers,
  farScrewdriverWrench,
  farShareNodes,
  farSortNumericDown,
  farSortNumericUp,
  farSpinnerThird,
  farSquarePollVertical,
  farStar,
  farStars,
  farSun,
  farSunBright,
  farTableLayout,
  farThumbsDown,
  farThumbsUp,
  farTrashCan,
  farTriangleExclamation,
  farTvRetro,
  farUpRightAndDownLeftFromCenter,
  farUser,
  farUserPlus,
  farUsersMedical,
  farWindow,
  farWindowRestore,
  farXmark,

  // Light icons
  falBookmark,
  falCopy,
  falPlus,
  farArrowLeftToLine,
  falRectangleHistory,
  falRotateReverse,

  // DuoTone icons
  fadSparkles,
  fadPollPeople,

  // Custom icons
  fakArrowUTurnUpLeft,
  fakArrowUTurnUpRight,
  fakFanatics,
  fakInteractiveCountdown,
  fakInteractiveCta,
  fakInteractiveGraphic,
  fakInteractiveHashtagMeter,
  fakInteractiveHashtagPoll,
  fakInteractiveHeatmap,
  fakInteractiveLeaderboard,
  fakInteractivePoll,
  fakInteractivePollResults,
  fakInteractiveRedditPoll,
  fakInteractiveTwitterPoll,
  fakInteractiveVimeo,
  fakInteractiveYoutube,
  fakLightFolderCirclePlus,
  fakPhotoshop,
  fakRegularArrowDownShortWideClock,
  fakRegularArrowUpShortWideClock,
  fakRegularCodeUser,
  fakRegularFolderCirclePlus,
  fakRegularLockKeyholeRotateRight,
  fakRegularScrewdriverWrenchUser,
  fakRegularUsersRotateRight,
  fakSocialCarousel,
  fakSocialCinematic,
  fakSocialGrid,
  fakSocialIsolated,
  fakSocialLowerthird,
  fakSocialLowerthirdscroll,
  fakSocialMural,
  fakSocialStories,
  fakSocialTicker,
  fakSocialWaterfall,
  fakSportradar,
  fakTagAnalytics2,
  fakTagGraphics,
  fakTagHome,
  fakTagInteractive,
  fakTagProducer,
  fakTagShareit,
  fakTagSocial,
  fakTgbPages,
  fakFanatics,
  fakSolidTextPen,
  fakHandPointClick,

  // Light icons
  falMessageQuote,

  // Social Brands
  faFacebook,
  faGoogle,
  faInstagram,
  faXTwitter,
  faAmazon,
  faCcStripe,
  fakThreads,
);

// Initialize Userpilot
if (USERPILOT_TOKEN) {
  Userpilot.initialize(USERPILOT_TOKEN);
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.info('[Userpilot] Initialized SDK for local development.');
  }
} else if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.warn('[Userpilot] Missing VITE_USERPILOT_TOKEN. Resource Center triggers will not work locally.');
}

const app = createApp(App);

app.use(Vue3Lottie);
app.use(createPinia());
app.use(launchDarklyPlugin({
  userApi: USER_API,
  clientId: LAUNCH_DARKLY_CLIENT_ID,
}));

app.use(router);

// Give router access to app instance for LaunchDarkly client
setAppInstance(app);

app.use(PrimeVue);
app.use(ConfirmationService);
app.use(DialogService);
app.use(ToastService);
app.use(plugin, defaultConfig);

instrument(app, router); // Sentry setup

app.directive('tooltip', Tooltip);

app.component('FontAwesomeIcon', FontAwesomeIcon);

app.mount('#app');
